import React, {useState} from 'react';
import {motion, AnimatePresence} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiChevronLeft, FiChevronRight} = FiIcons;

const TestimonialsSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      quote: "Katie helped me see that I wasn't alone in this process. Her guidance gave me the confidence to make decisions I never thought I could make on my own. She truly changed my life.",
      author: "Rebecca M."
    },
    {
      quote: "Working with Katie was a game-changer. She helped me focus on what really mattered and gave me tools to handle the emotional ups and downs with grace and strength.",
      author: "Jennifer L."
    },
    {
      quote: "I can't imagine going through my divorce without Katie's support. She helped me find my voice and my strength when I felt completely lost and overwhelmed.",
      author: "Michelle R."
    },
    {
      quote: "Katie's approach is both practical and compassionate. She helped me create a plan for my future while processing all the difficult emotions that came with my divorce.",
      author: "Amanda K."
    }
  ];

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section className="py-20 lg:py-32 bg-white">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{opacity: 0, y: 30}}
          whileInView={{opacity: 1, y: 0}}
          transition={{duration: 0.8}}
          viewport={{once: true}}
          className="text-center mb-16"
        >
          <span className="text-sage-600 font-inter text-sm font-medium uppercase tracking-wider mb-4 block">
            Client Stories
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-canela font-light text-gray-900 mb-6 leading-tight">
            Hear From Women I've Helped
          </h2>
          <p className="text-lg text-gray-600 font-inter max-w-2xl mx-auto">
            Real stories from real women who found their strength and clarity through coaching.
          </p>
        </motion.div>

        <div className="relative">
          <AnimatePresence mode="wait">
            <motion.div
              key={currentIndex}
              initial={{opacity: 0, y: 20}}
              animate={{opacity: 1, y: 0}}
              exit={{opacity: 0, y: -20}}
              transition={{duration: 0.5}}
              className="text-center"
            >
              <div className="bg-sage-50 p-8 md:p-12 rounded-2xl mb-8">
                <blockquote className="text-lg md:text-xl font-inter text-gray-700 leading-relaxed mb-8 italic">
                  "{testimonials[currentIndex].quote}"
                </blockquote>
                <div className="flex items-center justify-center">
                  <div className="text-center">
                    <cite className="text-sage-600 font-inter font-semibold text-lg not-italic">
                      {testimonials[currentIndex].author}
                    </cite>
                  </div>
                </div>
              </div>
            </motion.div>
          </AnimatePresence>

          {/* Navigation */}
          <div className="flex justify-center items-center space-x-6">
            <button
              onClick={prevTestimonial}
              className="p-3 rounded-full bg-white border border-gray-200 text-gray-600 hover:bg-sage-50 hover:text-sage-600 hover:border-sage-300 transition-all duration-200 shadow-sm hover:shadow-md"
            >
              <SafeIcon icon={FiChevronLeft} className="h-5 w-5" />
            </button>

            <div className="flex space-x-2">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentIndex(index)}
                  className={`w-3 h-3 rounded-full transition-all duration-200 ${
                    index === currentIndex ? 'bg-sage-500' : 'bg-gray-300 hover:bg-sage-300'
                  }`}
                />
              ))}
            </div>

            <button
              onClick={nextTestimonial}
              className="p-3 rounded-full bg-white border border-gray-200 text-gray-600 hover:bg-sage-50 hover:text-sage-600 hover:border-sage-300 transition-all duration-200 shadow-sm hover:shadow-md"
            >
              <SafeIcon icon={FiChevronRight} className="h-5 w-5" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;